import { useState } from "react";
import { StickyNote } from "lucide-react";
import { fmtDate } from "@/lib/crmApi";

export const PickUpBox = ({ note, onSave, saving }) => {
  const [text, setText] = useState("");
  const save = () => onSave(text.trim(), () => setText(""));
  return (
    <section data-testid="pickup-box" className="rounded-2xl bg-amber-50 border border-amber-200 p-5">
      <div className="flex items-center gap-2 text-amber-800">
        <StickyNote className="h-4 w-4" />
        <h2 className="text-sm font-semibold">Pick up from</h2>
        {note && <span data-testid="pickup-date" className="text-xs text-amber-700/80 ml-auto">{fmtDate(note.at)} · {note.by}</span>}
      </div>
      <p data-testid="pickup-text" className={`mt-2 text-base whitespace-pre-wrap ${note ? "text-amber-950" : "text-amber-700/60 italic"}`}>
        {note ? note.text : "No notes yet. Add where you left off."}
      </p>
      <div className="mt-4 flex flex-col sm:flex-row gap-2">
        <textarea data-testid="note-input" value={text} onChange={(e) => setText(e.target.value)} rows={2} placeholder="Add a note…"
          className="flex-1 rounded-xl border border-amber-200 bg-white px-3 py-2.5 text-sm outline-none focus:border-amber-400 resize-none" />
        <button data-testid="note-save" disabled={!text.trim() || saving} onClick={save}
          className="h-12 sm:h-auto px-5 rounded-xl bg-amber-500 text-white font-medium hover:bg-amber-600 disabled:opacity-40 transition-colors">
          {saving ? "Saving…" : "Save note"}
        </button>
      </div>
    </section>
  );
};
